import * as React from 'react';
import ClipboardPencilOutlined from './clipboard-pencil-outlined';
import ClipboardPencilFilled from './clipboard-pencil-filled';
import type { IconCombinedProps } from './types';
const ClipboardPencilCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ClipboardPencilFilled ref={ref} {...rest} />;
  }
  return <ClipboardPencilOutlined ref={ref} {...rest} />;
});
export default ClipboardPencilCombined;